import type { EnumUnion } from '@dresscode-frontend/utility-types';
import { CertificationKind } from '../../-constants';

/**
 * ベース資格一覧のソート可能なカラム
 */
export const CertificationOrderBy = {
  CERTIFICATION_NAME: 'CERTIFICATION_NAME',
  CERTIFICATION_CODE: 'CERTIFICATION_CODE',
  INDUSTRY_CATEGORY: 'INDUSTRY_CATEGORY',
  ISSUING_ORGANIZATION_NAME: 'ISSUING_ORGANIZATION_NAME',
  CERTIFICATIONS_HOLDERS_COUNT: 'CERTIFICATIONS_HOLDERS_COUNT',
  COMPLIANCE_RISK_LEVEL: 'COMPLIANCE_RISK_LEVEL'
} as const satisfies Record<string, string>;
export type CertificationOrderBy = EnumUnion<typeof CertificationOrderBy>;

/**
 * テーブルカラムの定義
 */
export const CertificationTableColumns = {
  certificationName: 'certificationName',
  certificationCode: 'certificationCode',
  industryCategory: 'industryCategory',
  issuingOrganizationName: 'issuingOrganizationName',
  certificationsHoldersCount: 'certificationsHoldersCount',
  complianceRiskLevel: 'complianceRiskLevel'
} as const;
export type CertificationTableColumns = (typeof CertificationTableColumns)[keyof typeof CertificationTableColumns];

/**
 * 資格一覧（全てと廃止済み）のソート可能なカラム
 */
export const CertificationAllAndArchivedOrderBy = {
  CERTIFICATION_NAME: 'CERTIFICATION_NAME',
  CERTIFICATION_CODE: 'CERTIFICATION_CODE',
  ISSUING_ORGANIZATION_NAME: 'ISSUING_ORGANIZATION_NAME',
  CERTIFICATION_HOLDERS_COUNT: 'CERTIFICATION_HOLDERS_COUNT',
  EFFECTIVE_FROM: 'EFFECTIVE_FROM',
  EFFECTIVE_TO: 'EFFECTIVE_TO'
} as const satisfies Record<string, string>;
export type CertificationAllAndArchivedOrderBy = EnumUnion<typeof CertificationAllAndArchivedOrderBy>;

/**
 * 資格一覧（全てと廃止済み）のテーブルカラムの定義
 */
export const CertificationAllAndArchivedTableColumns = {
  certificationName: 'certificationName',
  certificationCode: 'certificationCode',
  issuingOrganizationName: 'issuingOrganizationName',
  certificationsHoldersCount: 'certificationsHoldersCount',
  effectiveFrom: 'effectiveFrom',
  effectiveTo: 'effectiveTo'
} as const;
export type CertificationAllAndArchivedTableColumns = (typeof CertificationAllAndArchivedTableColumns)[keyof typeof CertificationAllAndArchivedTableColumns];

/**
 * 資格種別
 */
export const CertificationKindWithAll = {
  ...CertificationKind,
  ALL: 'ALL',
  ARCHIVED: 'ARCHIVED'
} as const;
export type CertificationKindWithAll = (typeof CertificationKindWithAll)[keyof typeof CertificationKindWithAll];